import { render } from "./PurchaseOrderEdit.vue?vue&type=template&id=3b3f7994&scoped=true"
import script from "./PurchaseOrderEdit.vue?vue&type=script&lang=js"
export * from "./PurchaseOrderEdit.vue?vue&type=script&lang=js"

import "./PurchaseOrderEdit.vue?vue&type=style&index=0&id=3b3f7994&scoped=true&lang=css"

import exportComponent from "D:\\DockerProjects\\armt_pos_v2_docker\\client\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3b3f7994"]])

export default __exports__